import * as React from "react";

export const HistoricIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M28 18c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10h2a8 8 0 1 0 1.865-5.135L24 25h-6v-6l2.447 2.446A9.98 9.98 0 0 1 28 18Zm1 5v4.585l3.243 3.243-1.415 1.415L27 28.413V23h2Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
